import React from 'react';
import { Block, DefaultText, MediumText } from '@guryou/html-components';

const TitleContainer = ({ title, subTitle }) => {
  return (
    <Block lg={10} md={12} xs={12} margin={0}>
      {title && <MediumText>{title}</MediumText>}
      {subTitle && <DefaultText>{subTitle}</DefaultText>}
    </Block>
  );
};

export default TitleContainer;
